"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Box_1 = __importDefault(require("@mui/material/Box"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const react_1 = __importDefault(require("react"));
const icons_1 = require("../../icons");
const themes_1 = require("../../themes");
const Dialog = ({ open, onClose, title, content, actions, children, ...rest }) => {
    const theme = (0, themes_1.useTheme)();
    const isMobile = (0, useMediaQuery_1.default)(theme.breakpoints.down('sm'));
    return (react_1.default.createElement(Dialog_1.default, { open: open, onClose: onClose, fullScreen: isMobile, "data-testid": "dialog", ...rest },
        react_1.default.createElement(DialogTitle_1.default, { style: { paddingBottom: theme.spacing(1) } },
            title,
            onClose && (react_1.default.createElement(Box_1.default, { sx: {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                } },
                react_1.default.createElement(IconButton_1.default, { onClick: onClose, "data-testid": "close-button" },
                    react_1.default.createElement(icons_1.Close, null))))),
        content && react_1.default.createElement(DialogContent_1.default, { style: { paddingTop: theme.spacing(1) } }, content),
        actions && react_1.default.createElement(DialogActions_1.default, null, actions),
        children));
};
exports.default = Dialog;
